defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/GameOptionCard',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/ActivePlayForGameOverlay',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlayCountdown',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Ensighten, NumberGamesUtils, Utils, ActivePlayForGameOverlay, PlayCountdown, CtaButton) {

    const GameOptionCard = {
      controller: function ({ controller, game }) {
        Object.assign(this, controller);

        this.gameType = game.gameType.toLowerCase();
        this.jackpot = controller.settings.jackpots[this.gameType];
        this.cardDictionary = this.rootDictionary.get.bind({ prefix: `ChooseGameType/${Utils.mapGameToDictionary(this.gameType)}/` });

        this.canNotBuyIn = () => {
          const now = new Date();
          const fundingTimeExceeded = now >= game.fundingEndTime;

          return !game.isOpen || fundingTimeExceeded;
        };

        this.createNewGame = () => {
          if (this.canNotBuyIn()) {
            return;
          }
          const gameNameExpectedByClub = NumberGamesUtils.formatNaming(this.gameType, 'alternativeName');
          const myOffersAndActivePlays = this.clubModel().fields.myOffersAndActivePlays();
          this.createNewGameLink = `${this.navigationPaths.createPlayChooseRowsPage}?klubId=${this.clubId()}&gameType=${this.gameType}`;
          this.gamesForSelectedGameType = myOffersAndActivePlays.filter(function (clubGame) {
            return clubGame.game.toLowerCase() === gameNameExpectedByClub;
          });

          // check if the selected game type has an open offer in the club games
          if (this.gamesForSelectedGameType.length > 0) {
            this.modal.setContent(m(ActivePlayForGameOverlay, {
              controller: this,
              template: this.modal.defaultContentTemplate
            }));
            this.modal.show();
            return;
          }

          // if no match is found in club offers we redirect the user to create a new game for the club
          Ensighten.pushGaEventOnPageRedirect('spil_sammen', 'start_nyt_spil', this.gameType);
          window.location = this.createNewGameLink;
        };
      },
      view: function (controller, { game }) {
        const canNotBuyIn = controller.canNotBuyIn();
        const cardBodyContent = () => {
          const now = new Date();
          let heading = controller.cardDictionary('PoolSize', { POOLSIZE: controller.jackpot });
          let subheading = controller.cardDictionary('PoolSizeText', { day: game.fundingDayName });

          if (canNotBuyIn) {
            heading = controller.dictionary('FundingTimeExceeded');
            subheading = controller.cardDictionary('SalesUpAgainSoon');
          } else if (Utils.isSameDay(now, game.fundingEndTime)) {
            subheading = PlayCountdown({
              countdownDictionary: controller.rootDictionary.get.bind({ prefix: 'ChooseGameType/Countdown/' }),
              timestamp: game.fundingEndTime
            });
          }

          return [
            m('.choose-game__card-heading', {
              class: canNotBuyIn ? 'choose-game__card-heading--smaller' : ''
            }, heading),
            m('.choose-game__card-subheading', subheading),
            !canNotBuyIn ? m('.choose-game__card-extra-field', controller.cardDictionary('GameStop', { day: game.fundingDayName })) : null
          ];
        };

        if (Utils.isMobile()) {
          return m('.choose-game__mobile-card', {
            onclick: controller.createNewGame,
            'data-uitest-id': `choose-game__${controller.gameType}`
          }, [
            m('.choose-game__card-icon', m('svg.card-icon', [
              m('use', { href: '/Components/DanskeSpil/Domain/Subscriptions/Graphics/SpriteSheets/WizardGameIcons.svg#' + controller.gameType })
            ])),
            m('.choose-game__card-body', [
              m('.choose-game__card-logo', m('svg.logo-icon', {
                class: controller.gameType
              }, [
                m('use', { href: Utils.mapGameIcon(controller.gameType) })
              ])),
              cardBodyContent()
            ]),
            canNotBuyIn ? null : m('svg.choose-game__card-arrow', m('use', { href: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#arrow' }))
          ]);
        }

        return m('.choose-game__card', {
          class: canNotBuyIn ? '' : 'choose-game__card--clickable',
          onclick: controller.createNewGame,
          'data-uitest-id': `choose-game__${controller.gameType}`
        }, [
          m('.choose-game__card-header', [
            m('.choose-game__card-logo', m('svg.logo-icon', [
              m('use', { href: Utils.mapGameIcon(controller.gameType) })
            ])),
            m('.choose-game__card-icon', m('svg.card-icon', [
              m('use', { href: '/Components/DanskeSpil/Domain/Subscriptions/Graphics/SpriteSheets/WizardGameIcons.svg#' + controller.gameType })
            ])),
          ]),
          m('.choose-game__card-body', cardBodyContent()),
          m('.choose-game__card-footer', CtaButton({
            text: controller.dictionary(canNotBuyIn ? 'SalesClosed' : 'SelectGameButton'),
            disabled: canNotBuyIn,
            options: ['primary', 'small'],
            disableTracking: true,
          }))
        ]);
      }
    };

    return GameOptionCard;
  });
